import Box from '@zenbusiness/zui/Box';
import { styled } from '@zenbusiness/zui/styles';

const GreenCircleStyle = () => ({
  backgroundColor: '#D9FEC5',
  width: '32px',
  height: '32px',
  borderRadius: '100px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: '18px'
});

const GridStyle = () => ({
  display: 'grid',
  marginBottom: '20px',
  alignItems: 'center',
  gridTemplateColumns: '40px auto',
  gridTemplateAreas: `"icon title"
  "space content"`
});

const IconAreaStyle = () => ({
  gridArea: 'icon'
});

const TitleAreaStyle = () => ({
  gridArea: 'title'
});

export const GreenCircle = styled('div')(GreenCircleStyle);
export const GridStyled = styled(Box)(GridStyle);
export const IconAreaStyled = styled(Box)(IconAreaStyle);
export const TitleAreaStyled = styled(Box)(TitleAreaStyle);
